<template>
  <nav>
    <MarketplaceMobileNav class="marketplace-nav d-lg-none">
    </MarketplaceMobileNav>
    <div class="marketplace-nav d-none d-lg-flex justify-content-end bg-body">
      <div class="marketplace-sidebar position-fixed overflow-auto d-block top-0 bottom-0 start-0 px-0">
        <div class="d-flex flex-column h-100">
          <MarketplaceLogo />
          <div class="sidebar-nav px-8 flex-grow-1">
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import MarketplaceMobileNav from '~/components/marketplace/MarketplaceMobileNav'
import MarketplaceLogo from '~/components/marketplace/MarketplaceLogo'

export default {
  name: "SimpleMarketplaceSidebar",
  components: {
    MarketplaceMobileNav,
    MarketplaceLogo,
  },
  props: {
    appName: String
  }
}
</script>

<style lang="scss" scoped>
.marketplace-nav {
  width: 100vw;
  position: fixed;
  z-index: 1010; // This value must be higher than it's children's z-index values or children may not appear above other DOM elements
}

.marketplace-sidebar {
  z-index: $zindex-fixed;
  background-color: $neutral-200;
  width: 320px;
  border-right: 1px solid $background-200;
}

.sidebar-nav {
  // Spaced to match .marketplace-page in marketplace.vue layout.
  margin-top: 142px;
}
</style>
